import React from 'react';

const GenesPage = () => {
  return (
      <div className="page-container-wrapper max-width-default padding-default">
        <div className="page-header">
          <h1>
            <i className="fas fa-utensils"></i>
            Gene's
          </h1>
          <p>A brief history of a Gene's, a restaurant that meant so much to the owners, staff, & loyal customers.</p>
        </div>
        
        <div className="page-content">
          <div className="section">
            <div className="section-header">
              <div className="section-icon">
                <i className="fas fa-suitcase-rolling"></i>
              </div>
              <h2>Gene's Restaurant</h2>
            </div>
            <p>
    For over 60 years Gene's was a family owned and operated restaurant. Gene & Jean founded the orginal restaurant on Queen Street in the 1950s.  I don't know when but they eventually relocated to 1219 South Main Street, Plantsville, CT 06479.<br></br>
		Purchased by Pasquale, Giuseppina, Connie, & Ralph in the late 1980s. The staff, mostly family & friends, worked together making memories with their customers for over 20 great years.<br></br>
		If you visit today you'll find that you can still grab some food, not from Gene's but from the current owner's of the property <a href="https://slidersgrillbar.com/southington-plantsville/" target="_blank" rel="noreferrer">Slider's Grill & Bar</a>
            </p>
            
            <div className="cta-buttons">
              <button className="cta-btn primary">
                <i className="fas fa-map-marked-alt"></i>
                Explore Recipes
              </button>
              <button className="cta-btn secondary">
                <i className="fas fa-camera"></i>
                View Photos
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};

export default GenesPage;